export default __webpack_public_path__ + "static/media/img2.bc329f28.png";